/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * Transform given string from dd/mm/yyyy format to yyyy-mm-dd
 */
const stringToAPIDateFormat = (value: string): string => {
  // Date constructor use mm/dd/yyyy date format, dd/mm/yyyy doesn't works
  const [day, month, year] = value.split('/');

  // Create date, otherwise return 'Invalid Date'
  const dateFromParam = new Date(+year, +month - 1, +day);

  // Allows to return yyyy-mm-dd format
  return dateFromParam.toLocaleDateString('en-CA');
};

export default stringToAPIDateFormat;
